module.exports = __webpack_public_path__ + "static/media/tty.3f7b9424.svg";